import { v4 as uuidv4 } from "uuid";
export class PMOTagModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.description = "";
        this.color = "";
        this.createdOnAsString = "";
        this.createdBy = uuidv4();
        this.ownedBy = null;
        this.teamId = null;
    }
}
export default class PMOTag extends PMOTagModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
